import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { ArticleFragment } from '@/pages/graphql/queries/GetArticleByUrl.query';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideItemCondensed',
  props: {
    article: null,
    index: null
  },
  setup(__props: any) {

const props = __props as { article: ArticleFragment; index: number }



const articleImage = computed(() => {
	const backdropIndex = props.article.mainObjects[0].node.content.backdrops[props.index] ? props.index : 0;
	return props.article.mainObjects[0].node.content.backdrops[backdropIndex].backdropUrl;
});

const trimH1Tags = (string: string) => {
	return string.substring(4, string.length - 5);
};

const articleTitle = computed(() => {
	return trimH1Tags(props.article.content.title || '');
});

return { __sfc: true,props, articleImage, trimH1Tags, articleTitle, PictureComp }
}

})